import { useRouter } from '@tanstack/react-router';
import { useRegisterBreadcrumbs } from '@/services/breadcrumbs';
import { generatePath } from '@/services/router/generate-path';

/** The migrated directory index, which redirects on to the Connections tab. */
const INTEGRATIONS_INDEX_PATH = '/workspaces/:workspaceId/integrations';

/** The workspace's API credentials, which moved to Hydra with FPS-2224. */
export function useApiCredentialsHref(workspaceId: string): string {
  return generatePath('/workspaces/:workspaceId/settings/api_credentials', { workspaceId });
}

/**
 * The merge-options settings page. The anonymous-events merge setting lives
 * there; `/settings/anonymous_events` only exists to redirect old bookmarks.
 */
export function useMergeOptionsHref(workspaceId: string): string {
  return generatePath('/workspaces/:workspaceId/settings/merge_options', { workspaceId });
}

export function useWorkspaceSettingsHref(workspaceId: string): string {
  return generatePath('/workspaces/:workspaceId/settings/edit', { workspaceId });
}

export function useCustomerioBreadcrumbs(workspaceId: string): void {
  const router = useRouter();

  useRegisterBreadcrumbs([
    {
      id: 'integrations',
      text: 'Integrations',
      href: generatePath(INTEGRATIONS_INDEX_PATH, { workspaceId }),
    },
    {
      id: 'integrations_customerio',
      text: 'Customer.io',
      href: router.buildLocation({
        to: '/workspaces/$workspaceId/integrations/customerio',
        params: { workspaceId },
      }).href,
    },
  ]);
}
